import React from "react";
import "./Card.scss";
import * as dayjs from "dayjs";
import * as conf from "../../../config";
import noPhoto from "../../images/newsIcon.svg";
import { Link } from "react-router-dom";
import { useStoreState } from "easy-peasy";

const FrontPageCard = ({ card, news }) => {
  const textColor = useStoreState((state) => state.color.textColor);
  return (
    <div className="innerCard">
      <div className="date">
        <div className="day">{dayjs(card.date).format("DD")}</div>
        <div className="month">/{dayjs(card.date).format("MM")}</div>
      </div>
      <div
        className="pic"
        style={{
          backgroundImage: `url(${
            card.media[0] ? conf.API_HOST + card.media[0].url : noPhoto
          })`,
          backgroundColor: news ? textColor : "transparent",
          backgroundSize: card.media[0] ? "cover" : "85%",
        }}
      ></div>
      <div className="post">
        <Link to={"/news/" + card.slug}>
          <div className="title">{card.title}</div>
        </Link>
        <div
          className="text ql-editor"
          dangerouslySetInnerHTML={{ __html: card.post }}
        ></div>
      </div>
    </div>
  );
};

export default FrontPageCard;
